// Mirror the investor deck atmosphere on public pages.
export function BrandAtmosphere() {
  return (
    <div className="signup-deck-atmosphere" aria-hidden="true">
      <span className="signup-deck-wash" />
      <span className="signup-deck-hero-wash" />
      <span className="signup-deck-hero-fill" />
      <span className="signup-deck-vignette" />
      <span className="pitch-grain signup-deck-grain" />
    </div>
  );
}
